import React from 'react';
import "./App.css";
import { Toaster } from 'sonner';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import OverviewSection from './components/OverviewSection';
import SitePlanSection from './components/SitePlanSection';
import TenantMixSection from './components/TenantMixSection';
import LocationSection from './components/LocationSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <Header />
      <main>
        <HeroSection />
        <OverviewSection />
        <SitePlanSection />
        <TenantMixSection />
        <LocationSection />
        <ContactSection />
        <Footer />
      </main>
    </div>
  );
}

export default App;
